import React from "react";

/**
 * @component StatusIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <StatusIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const StatusIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="StatusIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.579 6.003a1 1 0 01.875.696l2.3 7.285 1.372-2.47A1 1 0 0116 11h2a1 1 0 110 2h-1.412l-2.214 3.986a1 1 0 01-1.828-.185L10.29 9.656l-1.396 2.791A1 1 0 018 13H6a1 1 0 110-2h1.382l2.224-4.447a1 1 0 01.973-.55z"
      />
    </svg>
  )
);
StatusIcon.displayName = "StatusIcon";
export default StatusIcon;
